import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import ValueProps from "../components/ValueProps";
import UseCases from "../components/UseCases";
import Workflow from "../components/Workflow";
import Trust from "../components/Trust";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";

export default function Landing() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.slice(1);
            const tryScroll = (attempts = 0) => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else if (attempts < 10) {
                    setTimeout(() => tryScroll(attempts + 1), 100);
                }
            };
            tryScroll();
        }
    }, [location]);

    return (
        <div data-testid="landing-page" className="bg-ink-950 text-white">
            <Navbar />
            <main>
                <Hero />
                <Services />
                <ValueProps />
                <UseCases />
                <Workflow />
                <Trust />
                <ContactCTA />
            </main>
            <Footer />
        </div>
    );
}
